var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { staticClass: "mx-3", attrs: { row: "", wrap: "", align: "center" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", align: "center" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cargando,
                      expression: "cargando"
                    }
                  ],
                  staticStyle: {
                    width: "100%",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center"
                  }
                },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        "font-size": "1.6vmin",
                        "font-weight": "400"
                      }
                    },
                    [
                      _vm._v(
                        "\n          Se está cargando la información, espere unos segundos...\n        "
                      )
                    ]
                  )
                ]
              ),
              _c("v-progress-linear", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cargando,
                    expression: "cargando"
                  }
                ],
                attrs: { indeterminate: "", color: "primary" }
              }),
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit()
                    }
                  }
                },
                [
                  _c("div", { attrs: { id: "gridPrincipal" } }, [
                    _c(
                      "div",
                      { attrs: { id: "subgridA" } },
                      _vm._l(_vm.filtros, function(filtro) {
                        return _c(
                          "div",
                          { key: filtro.cod },
                          [
                            filtro.tipo.toLowerCase() === "dropdown"
                              ? _c("v-autocomplete", {
                                  attrs: {
                                    "data-vv-name": filtro.cod,
                                    label: filtro.name,
                                    items: filtro.data,
                                    "item-text": "desc",
                                    "item-value": "cod",
                                    "error-messages": _vm.errors.collect(
                                      filtro.cod
                                    ),
                                    multiple: _vm.getMultiple(filtro),
                                    "menu-props": { closeOnContentClick: true }
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.changeFiltro($event, filtro)
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm.getMultiple(filtro)
                                        ? {
                                            key: "prepend-item",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-list-tile",
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        label:
                                                          "Seleccionar todos"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.selectAll(
                                                            filtro
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.checkAll[
                                                            filtro.cod
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.checkAll,
                                                            filtro.cod,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "checkAll[filtro.cod]"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("v-divider")
                                              ]
                                            },
                                            proxy: true
                                          }
                                        : null,
                                      {
                                        key: "selection",
                                        fn: function(ref) {
                                          var item = ref.item
                                          var index = ref.index
                                          return [
                                            index < 1 &&
                                            !_vm.checkAll[filtro.cod]
                                              ? _c("v-chip", [
                                                  _c("span", [
                                                    _vm._v(_vm._s(item.desc))
                                                  ])
                                                ])
                                              : _vm._e(),
                                            index >= 1 &&
                                            index < 2 &&
                                            !_vm.checkAll[filtro.cod]
                                              ? _c("v-chip", [
                                                  _vm._v(
                                                    "\n                    ...\n                  "
                                                  )
                                                ])
                                              : _vm._e(),
                                            index < 1 &&
                                            _vm.checkAll[filtro.cod]
                                              ? _c("v-chip", [
                                                  _vm._v(
                                                    "\n                    Todo\n                  "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        }
                                      },
                                      {
                                        key: "seleccion",
                                        fn: function(ref) {
                                          var item = ref.item
                                          var index = ref.index
                                          return [
                                            index === 0
                                              ? _c("v-chip", [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        this.esquema.estructura[
                                                          filtro.cod
                                                        ]
                                                      )
                                                    )
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(_vm._s(item.desc))
                                                  ])
                                                ])
                                              : _vm._e(),
                                            index === 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "grey--text caption"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "(+" +
                                                        _vm._s(
                                                          _vm.printCantidadSeleccion(
                                                            filtro
                                                          )
                                                        ) +
                                                        " otros)"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.esquema.estructura[filtro.cod],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.esquema.estructura,
                                        filtro.cod,
                                        $$v
                                      )
                                    },
                                    expression: "esquema.estructura[filtro.cod]"
                                  }
                                })
                              : _vm._e(),
                            filtro.tipo === "date" && filtro.cod == "fini"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ma-6",
                                    attrs: { required: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.getDataPiker(filtro.cod)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-combobox", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        "data-vv-name": filtro.cod,
                                        "error-messages": _vm.errors.collect(
                                          filtro.cod
                                        ),
                                        label: filtro.name,
                                        "prepend-icon": "event",
                                        required: "",
                                        chips: "",
                                        readonly: "",
                                        "deletable-chips": ""
                                      },
                                      model: {
                                        value:
                                          _vm.esquema.estructura[filtro.cod],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.esquema.estructura,
                                            filtro.cod,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "esquema.estructura[filtro.cod]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            filtro.tipo === "date" && filtro.cod == "ffin"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ma-6",
                                    attrs: { required: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.getDataPiker(filtro.cod)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-combobox", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        "data-vv-name": filtro.cod,
                                        "error-messages": _vm.errors.collect(
                                          filtro.cod
                                        ),
                                        label: filtro.name,
                                        "prepend-icon": "event",
                                        required: "",
                                        chips: "",
                                        readonly: "",
                                        "deletable-chips": ""
                                      },
                                      model: {
                                        value:
                                          _vm.esquema.estructura[filtro.cod],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.esquema.estructura,
                                            filtro.cod,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "esquema.estructura[filtro.cod]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "subgridB" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "#27488E",
                              fab: "",
                              small: "",
                              dark: "",
                              type: "submit"
                            }
                          },
                          [_c("v-icon", [_vm._v("search")])],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c("br"),
          _c("br")
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-layout",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-xl": "", fluid: "" } },
                [
                  _c(
                    "v-layout",
                    { staticClass: "mb-4", attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("v-flex", { attrs: { md12: "" } }, [
                            _c("h2", { staticClass: "h2_title" }, [
                              _vm._v(_vm._s(_vm.esquema.label))
                            ])
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _c("v-divider"),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cargandoDash,
                          expression: "cargandoDash"
                        }
                      ],
                      staticStyle: {
                        width: "100%",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center",
                        "margin-top": "5px"
                      }
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticStyle: {
                            "font-size": "1.6vmin",
                            "font-weight": "400"
                          }
                        },
                        [
                          _vm._v(
                            "\n            Se está cargando la información, espere unos segundos...\n          "
                          )
                        ]
                      )
                    ]
                  ),
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cargandoDash,
                        expression: "cargandoDash"
                      }
                    ],
                    attrs: { indeterminate: "", color: "primary" }
                  }),
                  _c("br"),
                  _c("br"),
                  _c("GraficosGrid")
                ],
                1
              ),
              _c(
                "v-layout",
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "290" },
                      model: {
                        value: _vm.dateStartDialog,
                        callback: function($$v) {
                          _vm.dateStartDialog = $$v
                        },
                        expression: "dateStartDialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-date-picker", {
                            attrs: { range: "", "event-color": "#27488E" },
                            on: { change: _vm.changedatetimeini },
                            model: {
                              value: _vm.fechaini,
                              callback: function($$v) {
                                _vm.fechaini = $$v
                              },
                              expression: "fechaini"
                            }
                          }),
                          _c("v-text-field", {
                            attrs: {
                              type: "time",
                              "prepend-icon": "access_time",
                              label: "Hora desde",
                              "background-color": "white"
                            },
                            on: { change: _vm.changedatetimeini },
                            model: {
                              value: _vm.hourini,
                              callback: function($$v) {
                                _vm.hourini = $$v
                              },
                              expression: "hourini"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "290" },
                      model: {
                        value: _vm.dateEndDialog,
                        callback: function($$v) {
                          _vm.dateEndDialog = $$v
                        },
                        expression: "dateEndDialog"
                      }
                    },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          range: "",
                          "event-color": "#27488E",
                          min: _vm.fechaini
                        },
                        on: { change: _vm.changedatetimefin },
                        model: {
                          value: _vm.fechafin,
                          callback: function($$v) {
                            _vm.fechafin = $$v
                          },
                          expression: "fechafin"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          type: "time",
                          "prepend-icon": "access_time",
                          label: "Hora fin",
                          "background-color": "white"
                        },
                        on: { change: _vm.changedatetimefin },
                        model: {
                          value: _vm.hourfin,
                          callback: function($$v) {
                            _vm.hourfin = $$v
                          },
                          expression: "hourfin"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }